export const SECTIONS = Object.freeze({
  HOUSE: 'house',
  CONTACTS: 'contacts',
});

export const HOUSE_ADDRESS_ITEMS = Object.freeze({
  FLOOR: 'floor',
  TYPE: 'tipo',
});
